var gridGroupAdvSearch = null, treeGroupAdvSearch = null, gridRegionAdvSearch = null, advSearch = null, isAdvSearch = false;

function DoAdvSearchC(response) {
    if (advSearch.AddressBookSearchId == '00000000-0000-0000-0000-000000000000')
        advSearch.AddressBookSearchTempId = response;

    tbSearch.tryDisableItem('search_for');
    tbSearch.tryDisableItem('zip');
    tbSearch.tryDisableItem('radius');
    tbSearch.tryDisableItem('groups');
    tbSearch.tryDisableItem('search');
    InitializeGridMain(gridMainView);
}

function DoAdvSearch() {
    jQuery("#divGrid").removeClass('pjq-hidden');
    jQuery("#divAdvSearch").addClass('pjq-hidden');
    isAdvSearch = true;
    tbSearch.setItemText('adv_search', '<b>Advanced Search</b>');

    // if data needs to be saved first, do that.


    if (!jQuery('#adv-search-save').button('option', 'disabled')) {
        var groupIdList = '';
        if (settings.GroupLevel == 0) {
            if (gridGroupAdvSearch != null)
                groupIdList = gridGroupAdvSearch.getCheckedRows(0);
        }
        else {
            if (treeGroupAdvSearch != null)
                groupIdList = _.map(treeGroupAdvSearch.getAllChecked().split(','), function (val) { return val.replace(new RegExp('_.*'), '').replace('NONE', 0); }).join(',');
        }

        var regionIdList = '';
        if (gridRegionAdvSearch != null)
            regionIdList = gridRegionAdvSearch.getCheckedRows(0);

        //if (advSearch.AddressBookSearchId == '00000000-0000-0000-0000-000000000000') {

            PanteraScript.PanteraScriptService.SaveAddressBookSearchTemp(pjqSessionId,
				'00000000-0000-0000-0000-000000000000',
				jQuery('#save-adv-search-name').val(),
				jQuery('#search-business-legalname').val(),
				jQuery('#search-contact-private-sector').prop('checked') || false,
				jQuery('#search-contact-public-sector').prop('checked') || false,
				jQuery('#search-contact-union').prop('checked') || false,
				jQuery('#search-contact-nonunion').prop('checked') || false,
				jQuery('#search-contact-prev-wage').prop('checked') || false,
				jQuery('#search-contact-dbe').prop('checked') || false,
				jQuery('#search-contact-dvbe').prop('checked') || false,
				jQuery('#search-contact-mbe').prop('checked') || false,
				jQuery('#search-contact-sbe').prop('checked') || false,
				jQuery('#search-contact-sdvbe').prop('checked') || false,
				jQuery('#search-contact-wbe').prop('checked') || false,
				jQuery('#search-contact-isblacklisted').val() == 'true',
				jQuery('#search-company-isblacklisted').val() == 'true',
				GetSearchValue('pjq-adv-cfn', 1),
				GetSearchValue('pjq-adv-cfn', 2),
				GetSearchValue('pjq-adv-cfn', 3),
				GetSearchValue('pjq-adv-cfn', 4),
				GetSearchValue('pjq-adv-cfn', 5),
				GetSearchValue('pjq-adv-cfn', 6),
				GetSearchValue('pjq-adv-cfn', 7),
				GetSearchValue('pjq-adv-cfn', 8),
				GetSearchValue('pjq-adv-cfn', 9),
				GetSearchValue('pjq-adv-cfn', 10),
				GetSearchValue('pjq-adv-cfn', 11),
				GetSearchValue('pjq-adv-cfn', 12),
				GetSearchValue('pjq-adv-cfn', 13),
				GetSearchValue('pjq-adv-cfn', 14),
				GetSearchValue('pjq-adv-cfn', 15),
				GetSearchValue('pjq-adv-cfn', 16),
				GetSearchValue('pjq-adv-cfn', 17),
				GetSearchValue('pjq-adv-cfn', 18),
				GetSearchValue('pjq-adv-cfn', 19),
				GetSearchValue('pjq-adv-cfn', 20),
				GetSearchValue('pjq-adv-cfn', 21),
				GetSearchValue('pjq-adv-cfn', 22),
				GetSearchValue('pjq-adv-cfn', 23),
				GetSearchValue('pjq-adv-cfn', 24),
				GetSearchValue('pjq-adv-cfn', 25),
				GetSearchValue('pjq-adv-cfn', 26),
				GetSearchValue('pjq-adv-cfn', 27),
				GetSearchValue('pjq-adv-cfn', 28),
				GetSearchValue('pjq-adv-cfn', 29),
				GetSearchValue('pjq-adv-cfn', 30),
				GetSearchValue('pjq-adv-cfn', 31),
				GetSearchValue('pjq-adv-cfn', 32),
				GetSearchValue('pjq-adv-cfn', 33),
				GetSearchValue('pjq-adv-cfn', 34),
				GetSearchValue('pjq-adv-cfn', 35),
				GetSearchValue('pjq-adv-cfn', 36),
				GetSearchValue('pjq-adv-cfn', 37),
				GetSearchValue('pjq-adv-cfn', 38),
				GetSearchValue('pjq-adv-cfn', 39),
				GetSearchValue('pjq-adv-cfn', 40),
				GetSearchValue('pjq-adv-cfn', 41),
				GetSearchValue('pjq-adv-cfn', 42),
				GetSearchValue('pjq-adv-cfn', 43),
				GetSearchValue('pjq-adv-cfn', 44),
				GetSearchValue('pjq-adv-cfn', 45),
				GetSearchValue('pjq-adv-cfn', 46),
				GetSearchValue('pjq-adv-cfn', 47),
				GetSearchValue('pjq-adv-cfn', 48),
				GetSearchValue('pjq-adv-cfn', 49),
				GetSearchValue('pjq-adv-cfn', 50),
				jQuery('#search-contact-name').val(),
				jQuery('#search-contact-title').val(),
				jQuery('#search-contact-phone').val(),
				jQuery('#search-contact-ext').val(),
				jQuery('#search-contact-fax').val(),
				jQuery('#search-contact-cell').val(),
				jQuery('#search-contact-email').val(),
				jQuery('#search-contact-city').val(),
				(jQuery('#search-contact-country').val() == 'CA') ? jQuery('#search-contact-state-ca').val() : jQuery('#search-contact-state-us').val(),
				jQuery('#search-contact-zip').val(),
				jQuery('#search-contact-country').val(),
				jQuery('#search-contact-searchzip').val(),
				parseInt(jQuery('#search-contact-searchradius').val()),
				jQuery('#search-contact-searchallstates').prop('checked') || false,
				GetSearchValue('pjq-adv-fn', 1),
				GetSearchValue('pjq-adv-fn', 2),
				GetSearchValue('pjq-adv-fn', 3),
				GetSearchValue('pjq-adv-fn', 4),
				GetSearchValue('pjq-adv-fn', 5),
				GetSearchValue('pjq-adv-fn', 6),
				GetSearchValue('pjq-adv-fn', 7),
				GetSearchValue('pjq-adv-fn', 8),
				GetSearchValue('pjq-adv-fn', 9),
				GetSearchValue('pjq-adv-fn', 10),
				GetSearchValue('pjq-adv-fn', 11),
				GetSearchValue('pjq-adv-fn', 12),
				GetSearchValue('pjq-adv-fn', 13),
				GetSearchValue('pjq-adv-fn', 14),
				GetSearchValue('pjq-adv-fn', 15),
				GetSearchValue('pjq-adv-fn', 16),
				GetSearchValue('pjq-adv-fn', 17),
				GetSearchValue('pjq-adv-fn', 18),
				GetSearchValue('pjq-adv-fn', 19),
				GetSearchValue('pjq-adv-fn', 20),
				GetSearchValue('pjq-adv-fn', 21),
				GetSearchValue('pjq-adv-fn', 22),
				GetSearchValue('pjq-adv-fn', 23),
				GetSearchValue('pjq-adv-fn', 24),
				GetSearchValue('pjq-adv-fn', 25),
				GetSearchValue('pjq-adv-fn', 26),
				GetSearchValue('pjq-adv-fn', 27),
				GetSearchValue('pjq-adv-fn', 28),
				GetSearchValue('pjq-adv-fn', 29),
				GetSearchValue('pjq-adv-fn', 30),
				GetSearchValue('pjq-adv-fn', 31),
				GetSearchValue('pjq-adv-fn', 32),
				GetSearchValue('pjq-adv-fn', 33),
				GetSearchValue('pjq-adv-fn', 34),
				GetSearchValue('pjq-adv-fn', 35),
				GetSearchValue('pjq-adv-fn', 36),
				GetSearchValue('pjq-adv-fn', 37),
				GetSearchValue('pjq-adv-fn', 38),
				GetSearchValue('pjq-adv-fn', 39),
				GetSearchValue('pjq-adv-fn', 40),
				GetSearchValue('pjq-adv-fn', 41),
				GetSearchValue('pjq-adv-fn', 42),
				GetSearchValue('pjq-adv-fn', 43),
				GetSearchValue('pjq-adv-fn', 44),
				GetSearchValue('pjq-adv-fn', 45),
				GetSearchValue('pjq-adv-fn', 46),
				GetSearchValue('pjq-adv-fn', 47),
				GetSearchValue('pjq-adv-fn', 48),
				GetSearchValue('pjq-adv-fn', 49),
				GetSearchValue('pjq-adv-fn', 50),
				groupIdList,
				regionIdList,
				DoAdvSearchC,
				onScriptError);
        /*
        }
        else {
            PanteraScript.PanteraScriptService.SaveAddressBookSearch(pjqSessionId,
				advSearch.AddressBookSearchId,
				jQuery('#save-adv-search-name').val(),
				jQuery('#search-business-legalname').val(),
				jQuery('#search-contact-private-sector').prop('checked') || false,
				jQuery('#search-contact-public-sector').prop('checked') || false,
				jQuery('#search-contact-union').prop('checked') || false,
				jQuery('#search-contact-nonunion').prop('checked') || false,
				jQuery('#search-contact-prev-wage').prop('checked') || false,
				jQuery('#search-contact-dbe').prop('checked') || false,
				jQuery('#search-contact-dvbe').prop('checked') || false,
				jQuery('#search-contact-mbe').prop('checked') || false,
				jQuery('#search-contact-sbe').prop('checked') || false,
				jQuery('#search-contact-sdvbe').prop('checked') || false,
				jQuery('#search-contact-wbe').prop('checked') || false,
				jQuery('#search-contact-isblacklisted').val() == 'true' || false,
				jQuery('#search-company-isblacklisted').val() == 'true' || false,
				GetSearchValue('pjq-adv-cfn', 1),
				GetSearchValue('pjq-adv-cfn', 2),
				GetSearchValue('pjq-adv-cfn', 3),
				GetSearchValue('pjq-adv-cfn', 4),
				GetSearchValue('pjq-adv-cfn', 5),
				GetSearchValue('pjq-adv-cfn', 6),
				GetSearchValue('pjq-adv-cfn', 7),
				GetSearchValue('pjq-adv-cfn', 8),
				GetSearchValue('pjq-adv-cfn', 9),
				GetSearchValue('pjq-adv-cfn', 10),
				GetSearchValue('pjq-adv-cfn', 11),
				GetSearchValue('pjq-adv-cfn', 12),
				GetSearchValue('pjq-adv-cfn', 13),
				GetSearchValue('pjq-adv-cfn', 14),
				GetSearchValue('pjq-adv-cfn', 15),
				GetSearchValue('pjq-adv-cfn', 16),
				GetSearchValue('pjq-adv-cfn', 17),
				GetSearchValue('pjq-adv-cfn', 18),
				GetSearchValue('pjq-adv-cfn', 19),
				GetSearchValue('pjq-adv-cfn', 20),
				GetSearchValue('pjq-adv-cfn', 21),
				GetSearchValue('pjq-adv-cfn', 22),
				GetSearchValue('pjq-adv-cfn', 23),
				GetSearchValue('pjq-adv-cfn', 24),
				GetSearchValue('pjq-adv-cfn', 25),
				GetSearchValue('pjq-adv-cfn', 26),
				GetSearchValue('pjq-adv-cfn', 27),
				GetSearchValue('pjq-adv-cfn', 28),
				GetSearchValue('pjq-adv-cfn', 29),
				GetSearchValue('pjq-adv-cfn', 30),
				GetSearchValue('pjq-adv-cfn', 31),
				GetSearchValue('pjq-adv-cfn', 32),
				GetSearchValue('pjq-adv-cfn', 33),
				GetSearchValue('pjq-adv-cfn', 34),
				GetSearchValue('pjq-adv-cfn', 35),
				GetSearchValue('pjq-adv-cfn', 36),
				GetSearchValue('pjq-adv-cfn', 37),
				GetSearchValue('pjq-adv-cfn', 38),
				GetSearchValue('pjq-adv-cfn', 39),
				GetSearchValue('pjq-adv-cfn', 40),
				GetSearchValue('pjq-adv-cfn', 41),
				GetSearchValue('pjq-adv-cfn', 42),
				GetSearchValue('pjq-adv-cfn', 43),
				GetSearchValue('pjq-adv-cfn', 44),
				GetSearchValue('pjq-adv-cfn', 45),
				GetSearchValue('pjq-adv-cfn', 46),
				GetSearchValue('pjq-adv-cfn', 47),
				GetSearchValue('pjq-adv-cfn', 48),
				GetSearchValue('pjq-adv-cfn', 49),
				GetSearchValue('pjq-adv-cfn', 50),
				jQuery('#search-contact-name').val(),
				jQuery('#search-contact-title').val(),
				jQuery('#search-contact-phone').val(),
				jQuery('#search-contact-ext').val(),
				jQuery('#search-contact-fax').val(),
				jQuery('#search-contact-cell').val(),
				jQuery('#search-contact-email').val(),
				jQuery('#search-contact-city').val(),
				(jQuery('#search-contact-country').val() == 'CA') ? jQuery('#search-contact-state-ca').val() : jQuery('#search-contact-state-us').val(),
				jQuery('#search-contact-zip').val(),
				jQuery('#search-contact-country').val(),
				jQuery('#search-contact-searchzip').val(),
				parseInt(jQuery('#search-contact-searchradius').val()),
				jQuery('#search-contact-searchallstates').prop('checked') || false,
				GetSearchValue('pjq-adv-fn', 1),
				GetSearchValue('pjq-adv-fn', 2),
				GetSearchValue('pjq-adv-fn', 3),
				GetSearchValue('pjq-adv-fn', 4),
				GetSearchValue('pjq-adv-fn', 5),
				GetSearchValue('pjq-adv-fn', 6),
				GetSearchValue('pjq-adv-fn', 7),
				GetSearchValue('pjq-adv-fn', 8),
				GetSearchValue('pjq-adv-fn', 9),
				GetSearchValue('pjq-adv-fn', 10),
				GetSearchValue('pjq-adv-fn', 11),
				GetSearchValue('pjq-adv-fn', 12),
				GetSearchValue('pjq-adv-fn', 13),
				GetSearchValue('pjq-adv-fn', 14),
				GetSearchValue('pjq-adv-fn', 15),
				GetSearchValue('pjq-adv-fn', 16),
				GetSearchValue('pjq-adv-fn', 17),
				GetSearchValue('pjq-adv-fn', 18),
				GetSearchValue('pjq-adv-fn', 19),
				GetSearchValue('pjq-adv-fn', 20),
				GetSearchValue('pjq-adv-fn', 21),
				GetSearchValue('pjq-adv-fn', 22),
				GetSearchValue('pjq-adv-fn', 23),
				GetSearchValue('pjq-adv-fn', 24),
				GetSearchValue('pjq-adv-fn', 25),
				GetSearchValue('pjq-adv-fn', 26),
				GetSearchValue('pjq-adv-fn', 27),
				GetSearchValue('pjq-adv-fn', 28),
				GetSearchValue('pjq-adv-fn', 29),
				GetSearchValue('pjq-adv-fn', 30),
				GetSearchValue('pjq-adv-fn', 31),
				GetSearchValue('pjq-adv-fn', 32),
				GetSearchValue('pjq-adv-fn', 33),
				GetSearchValue('pjq-adv-fn', 34),
				GetSearchValue('pjq-adv-fn', 35),
				GetSearchValue('pjq-adv-fn', 36),
				GetSearchValue('pjq-adv-fn', 37),
				GetSearchValue('pjq-adv-fn', 38),
				GetSearchValue('pjq-adv-fn', 39),
				GetSearchValue('pjq-adv-fn', 40),
				GetSearchValue('pjq-adv-fn', 41),
				GetSearchValue('pjq-adv-fn', 42),
				GetSearchValue('pjq-adv-fn', 43),
				GetSearchValue('pjq-adv-fn', 44),
				GetSearchValue('pjq-adv-fn', 45),
				GetSearchValue('pjq-adv-fn', 46),
				GetSearchValue('pjq-adv-fn', 47),
				GetSearchValue('pjq-adv-fn', 48),
				GetSearchValue('pjq-adv-fn', 49),
				GetSearchValue('pjq-adv-fn', 50),
				groupIdList,
				regionIdList,
				DoAdvSearchC,
				onScriptError);
        } */
    }
    else
        InitializeGridMain(gridMainView);
}

function treeGroupAdvSearchclick(id) {
    if (id == 'NONE') {
    }
    else if (parseInt(id) <= 0) {
        if (treeGroupAdvSearch.hasChildren(id)) {
            if (treeGroupAdvSearch.getOpenState(id) == 1)
                treeGroupAdvSearch.closeItem(id);
            else
                treeGroupAdvSearch.openItem(id);
        }
        return;
    }
    if (treeGroupAdvSearch.isItemChecked(id))
        treeGroupAdvSearch.setCheck(id, 0);
    else
        treeGroupAdvSearch.setCheck(id, 1);
}

function InitializeAdvancedSearch(searchObj) {
    advSearch = searchObj;
    advSearch.IsCrossStateBoundaries = true;
    jQuery('.pjq-group-label').text(settings.GroupLabel);
    jQuery('.pjq-region-label').text(settings.RegionLabel);
    jQuery('#search-contact-prev-wage-label').text(settings.PrevailingWageLabel);
    jQuery('#adv-company-info-additional, #adv-contact-info-additional').accordion({
        collapsible: true,
        active: false,
        heightStyle: "content",
        autoHeight: false,
        clearStyle: true
    });
    jQuery('button,select', '#adv-search-commands').css('width', '100%');
    jQuery('#adv-search2, #adv-search-clear2, #adv-search-cancel2').css('min-width', '140px');
    jQuery('#adv-search-commands button, #adv-search2, #adv-search-clear2, #adv-search-cancel2').button();
    jQuery('#adv-search-set-default, #adv-search-update, #adv-search-delete').button('option', 'disabled', true);

    //jQuery("#search-contact-phone,#search-contact-fax,#search-contact-cell").mask('999-999-9999',{placeholder:" "});

    jQuery("#adv-contact-info-additional tbody tr td input.pjq-date-field-width, #adv-company-info-additional tbody tr td input.pjq-date-field-width").mask('99/99/9999', { placeholder: " " });
    jQuery("#adv-contact-info-additional tbody tr td input.pjq-numeric-field-width, #adv-company-info-additional tbody tr td input.pjq-numeric-field-width").each(function () {
        var minVal = 0;
        if (jQuery(this).attr('min') != '')
            minVal = parseInt(jQuery(this).attr('min'));
        var maxVal = 2147483647;
        if (jQuery(this).attr('max') != '')
            maxVal = parseInt(jQuery(this).attr('max'));
        if (!minVal || minVal == NaN)
            minVal = 0;
        if (!maxVal || maxVal == NaN)
            maxVal = 0;
        jQuery(this).spinner({ min: minVal, max: maxVal, step: 1 });
    });
    jQuery('#adv-contact-info-additional tbody tr td input.pjq-date-field-width,#adv-company-info-additional tbody tr td input.pjq-date-field-width').datepicker({
        showOn: "button",
        numberOfMonths: 3,
        showButtonPanel: true,
        buttonImage: "/i/calendar.png",
        buttonImageOnly: true,
        onSelect: function (name, sender) {
            validator.element('#' + jQuery(sender).attr('id'));
            EnableAdvSearch(true);
        }
    });
    jQuery("#adv-contact-info-additional select.pjq-choice-field-width, #adv-company-info-additional select.pjq-choice-field-width").each(function () {
        var x = jQuery(this).attr('data-choice-list').split(',');
        var i = 0;
        for (i = 0; i < x.length; i++) {
            jQuery(this).find("option[value='" + x[i] + "']").attr('selected', 'selected');
        }
    });
    jQuery("#adv-contact-info-additional div.pjq-multiple-choice-list, #adv-company-info-additional div.pjq-multiple-choice-list").each(function () {
        var x = jQuery(this).attr('data-choice-list').split(',');
        var i = 0;
        for (i = 0; i < x.length; i++) {
            jQuery(this).find("input[value='" + x[i] + "']").prop('checked', true);
        }
    });

    gridGroupAdvSearch = new dhtmlXGridObject('search-contact-groups');
    treeGroupAdvSearch = new dhtmlXTreeObject("search-contact-groups", "100%", "100%", 0);
    if (settings.GroupCount == 0) {
        jQuery('#adv-search-groups-header').addClass('pjq-hidden');
    }
    else {
        if (settings.GroupLevel > 0) {
            treeGroupAdvSearch.setImagePath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxTree/imgs/");
            treeGroupAdvSearch.enableCheckBoxes(1);
            treeGroupAdvSearch.enableMultiLineItems("300px");
            treeGroupAdvSearch.enableTreeLines(false);
            treeGroupAdvSearch.enableTreeImages(false);
            treeGroupAdvSearch.setOnClickHandler(treeGroupAdvSearchclick);
            treeGroupAdvSearch.attachEvent("onCheck", function (id, state) { EnableAdvSearch(true); });
            treeGroupAdvSearch.setDataMode('json');
            treeGroupAdvSearch.loadJSON('/DesktopModules/PJQAddressBook/GetGroupTree.aspx?sessionid=' + pjqSessionId + '&nogroup=1&x=' + (new Date).getTime(), function () {
                jQuery('#search-contact-groups div table tbody tr td table tbody tr td img').first().parent().css('display', 'none');
                jQuery('#search-contact-groups div table tbody tr td table tbody tr td img').first().parent().next().css('padding-left', '2px');

                var i = 0;
                var j = advSearch.GroupIdList.split(',');
                for (i = 0; i < j.length; i++) {
                    if (j[i] == '')
                        continue;
                    if (j[i] == '0')
                        treeGroupAdvSearch.setCheck('NONE', 1);
                    else
                        treeGroupAdvSearch.setCheck(j[i], 1);
                }
            });

            treeGroupAdvSearch.attachEvent("onCheck", function (id, state) {
                if (treeGroupAdvSearch.getLevel(id) == 1) {
                    var groupSubItems = treeGroupAdvSearch.getAllSubItems(id).split(',');
                    for (var i = 0; i < groupSubItems.length; i++) {
                        treeGroupAdvSearch.setCheck(groupSubItems[i], state);
                    }
                }
            })

        }
        else if (settings.GroupLevel == 0) {
            gridGroupAdvSearch.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');//path to images required by grid
            gridGroupAdvSearch.enableMultiline(true);
            gridGroupAdvSearch.setSkin(pjqGridTheme);
            gridGroupAdvSearch.setHeader("&nbsp;," + settings.GroupLabel + ",Count");
            gridGroupAdvSearch.setInitWidthsP("6,80,14");
            gridGroupAdvSearch.setColAlign("center,left,center");
            gridGroupAdvSearch.setColTypes("ch,ro,ro");
            gridGroupAdvSearch.setColSorting("na,na,na");
            gridGroupAdvSearch.enableTooltips("false,true,false");
            gridGroupAdvSearch.enableAutoHeight(true, 450);
            gridGroupAdvSearch.enableAutoWidth(true);
            gridGroupAdvSearch.attachEvent("onCheck", function (rId, cInd, state) { EnableAdvSearch(true); });
            gridGroupAdvSearch.init();
            gridGroupAdvSearch.attachEvent("onXLE", function (grid_obj) {
                if (!gridGroupAdvSearch.getRowId(0))
                    jQuery('#adv-search-groups-header').addClass('pjq-hidden');
            });

            gridGroupAdvSearch.loadXML('/DesktopModules/PJQAddressBook/GetGroupList.aspx?sessionid=' + pjqSessionId + '&x=' + (new Date).getTime(), function () {
                gridGroupAdvSearch.forEachRow(function (id) {
                    var groups = advSearch.GroupIdList.split(',');
                    if (jQuery.inArray(id, groups) != -1)
                        gridGroupAdvSearch.cells(id, 0).setChecked(true);
                });

            });
        }
    }

    gridRegionAdvSearch = new dhtmlXGridObject('search-contact-regions');
    if (settings.RegionCount == 0) {
        jQuery('#adv-search-regions-header').addClass('pjq-hidden');
    }
    else {
    	if(PJQ.app.session.get('masterUserId') === 23){
		    jQuery('#adv-search-regions-header').show();
	    }

        gridRegionAdvSearch.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');//path to images required by grid
        gridRegionAdvSearch.enableMultiline(true);
        gridRegionAdvSearch.setSkin(pjqGridTheme);
        gridRegionAdvSearch.setHeader("&nbsp;," + settings.RegionLabel + ",Count");
        gridRegionAdvSearch.setInitWidthsP("6,80,14");
        gridRegionAdvSearch.setColAlign("center,left,center");
        gridRegionAdvSearch.setColTypes("ch,ro,ro");
        gridRegionAdvSearch.setColSorting("na,na,na");
        gridRegionAdvSearch.enableTooltips("false,true,false");
        gridRegionAdvSearch.enableAutoHeight(true, 450);
        gridRegionAdvSearch.enableAutoWidth(true);
        gridRegionAdvSearch.attachEvent("onCheck", function (rId, cInd, state) { EnableAdvSearch(true); });
        gridRegionAdvSearch.init();
        gridRegionAdvSearch.loadXML('/DesktopModules/PJQAddressBook/GetRegionList.aspx?sessionid=' + pjqSessionId + '&x=' + (new Date).getTime(), function () {
            var regions = advSearch.RegionIdList.split(',');
            gridRegionAdvSearch.forEachRow(function (id) {
                if (gridRegionAdvSearch.getUserData(id, "RegionMemberCount") == "0") {
                    gridRegionAdvSearch.cells(id, 0).setDisabled(true);
                    gridRegionAdvSearch.setRowTextStyle(id, "color: gray; font-style: italic;");
                }
                if (jQuery.inArray(id, regions) != -1)
                    gridRegionAdvSearch.cells(id, 0).setChecked(true);
            });
        });
    }
    EnableAdvSearch(false);

    if (advSearch.AddressBookSearchId && advSearch.AddressBookSearchId != '00000000-0000-0000-0000-000000000000') {
        jQuery('#adv-search-load').val(advSearch.AddressBookSearchId);
        jQuery('#adv-search, #adv-search2, #adv-search-delete, #adv-search-set-default').button('option', 'disabled', false);
        if (advSearch.AddressBookSearchId == advSearch.DefaultAddressBookSearchId)
            jQuery('#adv-search-set-default').button('option', 'label', 'Remove Default Search');
        else
            jQuery('#adv-search-set-default').button('option', 'label', 'Set as Default');

    }

    jQuery('#search-contact-country').val(advSearch.Country ? advSearch.Country : 'US');

    advCountryChanged();
    jQuery('#search-contact-zip').val(advSearch.PostalCode);
    jQuery('#search-contact-searchzip').val(advSearch.SearchZip);
    if (jQuery('#search-contact-country').val() == 'CA')
        jQuery('#search-contact-state-ca').val(advSearch.StateProvince);
    else
        jQuery('#search-contact-state-us').val(advSearch.StateProvince);

    AdvSearchInactiveLogic();
}

function EnableAdvSearch(enabled) {
    if (enabled) {
        jQuery('#adv-search, #adv-search-save, #adv-search2').button('option', 'disabled', false);
        if (advSearch.AddressBookSearchId && advSearch.AddressBookSearchId != '00000000-0000-0000-0000-000000000000') {
            jQuery('#adv-search-update').button('option', 'disabled', false);
        }
        jQuery('#adv-search-set-default').button('option', 'disabled', true);

    }
    else
        jQuery('#adv-search, #adv-search-save, #adv-search2').button('option', 'disabled', true);

    return true;
}

function ClearAdvSearch() {
    tbSearch.tryEnableItem('search_for');
    tbSearch.tryEnableItem('zip');
    tbSearch.tryEnableItem('radius');
    tbSearch.tryEnableItem('groups');
    tbSearch.tryEnableItem('search');

    GetAdvancedSearch('00000000-0000-0000-0000-000000000000');
    //PanteraScript.PanteraScriptService.GetAdvancedSearchAB(pjqSessionId, '00000000-0000-0000-0000-000000000000', GetAdvSearchC, onScriptError);
}

function GetAdvancedSearch(savedSearchId, callback) {
    new PJQ.ajax.Request({
        endpoint:  PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts'
            },
            {
                endpoint: 'advancedsearchsettings',
                value: savedSearchId
            }]),
        isPascal: true
    }).post().done(function (data) {
        if (typeof callback === 'function')
            callback(data);
        else
            GetAdvSearchC(data);
    }).fail(function () {
    });
}

function CancelAdvSearch() {
    jQuery("#divGrid").removeClass('pjq-hidden');
    jQuery("#divAdvSearch").addClass('pjq-hidden');
    isAdvSearch = false;
    tbSearch.setItemText('adv_search', 'Advanced Search');

    tbSearch.enableItem('search_for');
    tbSearch.enableItem('zip');
    tbSearch.enableItem('radius');
    tbSearch.enableItem('groups');
    tbSearch.enableItem('search');

    InitializeGridMain(gridMainView);
}

function SaveAdvSearch() {
    jQuery('#save-adv-search-name').val('');
    ClearValidationError('#save-adv-search-name');
    var dlg = jQuery('#dialog-adv-search-save').dialog({
        resizable: false,
        height: 170,
        width: 600,
        title: 'Save Search',
        modal: true,
        draggable: false,
        buttons: {
            "Save": function () {
                if (jQuery('#save-adv-search-name').val().trim().length == 0) {
                    SetValidationError('#save-adv-search-name', 'Search Name is required.');
                    return;
                }
                advSearch.AddressBookSearchId = '00000000-0000-0000-0000-000000000000';
                SaveAdvSearchName(jQuery('#save-adv-search-name').val().trim());
                jQuery(this).dialog('close');
            }
        }
    });
}

function SaveAdvSearchName(name) {
    var groupIdList = '';
    if (settings.GroupLevel == 0) {
        if (gridGroupAdvSearch != null)
            groupIdList = gridGroupAdvSearch.getCheckedRows(0);
    }
    else {
        if (treeGroupAdvSearch != null)
            groupIdList = _.map(treeGroupAdvSearch.getAllChecked().split(','), function (val) { return val.replace(new RegExp('_.*'), '').replace('NONE', 0); }).join(',');
    }

    var regionIdList = '';
    if (gridRegionAdvSearch != null)
        regionIdList = gridRegionAdvSearch.getCheckedRows(0);

    PanteraScript.PanteraScriptService.SaveAddressBookSearch(pjqSessionId,
		advSearch.AddressBookSearchId,
		jQuery('#save-adv-search-name').val(),
		jQuery('#search-business-legalname').val(),
		jQuery('#search-contact-private-sector').prop('checked') || false,
		jQuery('#search-contact-public-sector').prop('checked') || false,
		jQuery('#search-contact-union').prop('checked') || false,
		jQuery('#search-contact-nonunion').prop('checked') || false,
		jQuery('#search-contact-prev-wage').prop('checked') || false,
		jQuery('#search-contact-dbe').prop('checked') || false,
		jQuery('#search-contact-dvbe').prop('checked') || false,
		jQuery('#search-contact-mbe').prop('checked') || false,
		jQuery('#search-contact-sbe').prop('checked') || false,
		jQuery('#search-contact-sdvbe').prop('checked') || false,
		jQuery('#search-contact-wbe').prop('checked') || false,
		jQuery('#search-contact-isblacklisted').val() == 'true',
		jQuery('#search-company-isblacklisted').val() == 'true',
		GetSearchValue('pjq-adv-cfn', 1),
		GetSearchValue('pjq-adv-cfn', 2),
		GetSearchValue('pjq-adv-cfn', 3),
		GetSearchValue('pjq-adv-cfn', 4),
		GetSearchValue('pjq-adv-cfn', 5),
		GetSearchValue('pjq-adv-cfn', 6),
		GetSearchValue('pjq-adv-cfn', 7),
		GetSearchValue('pjq-adv-cfn', 8),
		GetSearchValue('pjq-adv-cfn', 9),
		GetSearchValue('pjq-adv-cfn', 10),
		GetSearchValue('pjq-adv-cfn', 11),
		GetSearchValue('pjq-adv-cfn', 12),
		GetSearchValue('pjq-adv-cfn', 13),
		GetSearchValue('pjq-adv-cfn', 14),
		GetSearchValue('pjq-adv-cfn', 15),
		GetSearchValue('pjq-adv-cfn', 16),
		GetSearchValue('pjq-adv-cfn', 17),
		GetSearchValue('pjq-adv-cfn', 18),
		GetSearchValue('pjq-adv-cfn', 19),
		GetSearchValue('pjq-adv-cfn', 20),
		GetSearchValue('pjq-adv-cfn', 21),
		GetSearchValue('pjq-adv-cfn', 22),
		GetSearchValue('pjq-adv-cfn', 23),
		GetSearchValue('pjq-adv-cfn', 24),
		GetSearchValue('pjq-adv-cfn', 25),
		GetSearchValue('pjq-adv-cfn', 26),
		GetSearchValue('pjq-adv-cfn', 27),
		GetSearchValue('pjq-adv-cfn', 28),
		GetSearchValue('pjq-adv-cfn', 29),
		GetSearchValue('pjq-adv-cfn', 30),
		GetSearchValue('pjq-adv-cfn', 31),
		GetSearchValue('pjq-adv-cfn', 32),
		GetSearchValue('pjq-adv-cfn', 33),
		GetSearchValue('pjq-adv-cfn', 34),
		GetSearchValue('pjq-adv-cfn', 35),
		GetSearchValue('pjq-adv-cfn', 36),
		GetSearchValue('pjq-adv-cfn', 37),
		GetSearchValue('pjq-adv-cfn', 38),
		GetSearchValue('pjq-adv-cfn', 39),
		GetSearchValue('pjq-adv-cfn', 40),
		GetSearchValue('pjq-adv-cfn', 41),
		GetSearchValue('pjq-adv-cfn', 42),
		GetSearchValue('pjq-adv-cfn', 43),
		GetSearchValue('pjq-adv-cfn', 44),
		GetSearchValue('pjq-adv-cfn', 45),
		GetSearchValue('pjq-adv-cfn', 46),
		GetSearchValue('pjq-adv-cfn', 47),
		GetSearchValue('pjq-adv-cfn', 48),
		GetSearchValue('pjq-adv-cfn', 49),
		GetSearchValue('pjq-adv-cfn', 50),
		jQuery('#search-contact-name').val(),
		jQuery('#search-contact-title').val(),
		jQuery('#search-contact-phone').val(),
		jQuery('#search-contact-ext').val(),
		jQuery('#search-contact-fax').val(),
		jQuery('#search-contact-cell').val(),
		jQuery('#search-contact-email').val(),
		jQuery('#search-contact-city').val(),
		(jQuery('#search-contact-country').val() == 'CA') ? jQuery('#search-contact-state-ca').val() : jQuery('#search-contact-state-us').val(),
		jQuery('#search-contact-zip').val(),
		jQuery('#search-contact-country').val(),
		jQuery('#search-contact-searchzip').val(),
		parseInt(jQuery('#search-contact-searchradius').val()),
		jQuery('#search-contact-searchallstates').prop('checked') || false,
		GetSearchValue('pjq-adv-fn', 1),
		GetSearchValue('pjq-adv-fn', 2),
		GetSearchValue('pjq-adv-fn', 3),
		GetSearchValue('pjq-adv-fn', 4),
		GetSearchValue('pjq-adv-fn', 5),
		GetSearchValue('pjq-adv-fn', 6),
		GetSearchValue('pjq-adv-fn', 7),
		GetSearchValue('pjq-adv-fn', 8),
		GetSearchValue('pjq-adv-fn', 9),
		GetSearchValue('pjq-adv-fn', 10),
		GetSearchValue('pjq-adv-fn', 11),
		GetSearchValue('pjq-adv-fn', 12),
		GetSearchValue('pjq-adv-fn', 13),
		GetSearchValue('pjq-adv-fn', 14),
		GetSearchValue('pjq-adv-fn', 15),
		GetSearchValue('pjq-adv-fn', 16),
		GetSearchValue('pjq-adv-fn', 17),
		GetSearchValue('pjq-adv-fn', 18),
		GetSearchValue('pjq-adv-fn', 19),
		GetSearchValue('pjq-adv-fn', 20),
		GetSearchValue('pjq-adv-fn', 21),
		GetSearchValue('pjq-adv-fn', 22),
		GetSearchValue('pjq-adv-fn', 23),
		GetSearchValue('pjq-adv-fn', 24),
		GetSearchValue('pjq-adv-fn', 25),
		GetSearchValue('pjq-adv-fn', 26),
		GetSearchValue('pjq-adv-fn', 27),
		GetSearchValue('pjq-adv-fn', 28),
		GetSearchValue('pjq-adv-fn', 29),
		GetSearchValue('pjq-adv-fn', 30),
		GetSearchValue('pjq-adv-fn', 31),
		GetSearchValue('pjq-adv-fn', 32),
		GetSearchValue('pjq-adv-fn', 33),
		GetSearchValue('pjq-adv-fn', 34),
		GetSearchValue('pjq-adv-fn', 35),
		GetSearchValue('pjq-adv-fn', 36),
		GetSearchValue('pjq-adv-fn', 37),
		GetSearchValue('pjq-adv-fn', 38),
		GetSearchValue('pjq-adv-fn', 39),
		GetSearchValue('pjq-adv-fn', 40),
		GetSearchValue('pjq-adv-fn', 41),
		GetSearchValue('pjq-adv-fn', 42),
		GetSearchValue('pjq-adv-fn', 43),
		GetSearchValue('pjq-adv-fn', 44),
		GetSearchValue('pjq-adv-fn', 45),
		GetSearchValue('pjq-adv-fn', 46),
		GetSearchValue('pjq-adv-fn', 47),
		GetSearchValue('pjq-adv-fn', 48),
		GetSearchValue('pjq-adv-fn', 49),
		GetSearchValue('pjq-adv-fn', 50),
		groupIdList,
		regionIdList,
		SaveAdvSearchC,
		onScriptError);

}


function SaveAdvSearchC(response) {
    advSearch.AddressBookSearchId = response;
    GetAdvancedSearch(advSearch.AddressBookSearchId);
    //PanteraScript.PanteraScriptService.GetAdvancedSearchAB(pjqSessionId, advSearch.AddressBookSearchId, GetAdvSearchC, onScriptError);
}

function DeleteAdvSearch() {
    showInfoDialogAB('Delete Search', 'Are you sure you want to delete this Search?', 'ui-icon-alert', 'delete-adv-search');
}

function DeleteAdvSearchC(response) {
    GetAdvancedSearch('00000000-0000-0000-0000-000000000000');
    //PanteraScript.PanteraScriptService.GetAdvancedSearchAB(pjqSessionId, '00000000-0000-0000-0000-000000000000', GetAdvSearchC, onScriptError);
}

function LoadAdvSearch(ctl) {
    var val = jQuery(ctl).val();
    if (val && val.length > 0) {
        GetAdvancedSearch(val);
        //PanteraScript.PanteraScriptService.GetAdvancedSearchAB(pjqSessionId, val, GetAdvSearchC, onScriptError);
        return true;
    }
    else {
        jQuery('#adv-search-load').val(advSearch.AddressBookSearchId);
        return false;
    }
}

function GetSearchValue(attr, fieldNumber) {

    var retVal = '';
    jQuery("[" + attr + "='" + fieldNumber.toString() + "']").each(function () {
        var field = jQuery(this);
        if (field.prop('tagName') == 'INPUT') {
            if (retVal.length > 0)
                retVal += ',';
            retVal += field.val();
        }
        else if (field.prop('tagName') == 'SELECT')
            retVal += field.val();
        else if (field.prop('tagName') == 'DIV') {
            jQuery("input[type='checkbox']:checked", field).each(function () {
                retVal = retVal + jQuery(this).val() + ',';
            });
            if (retVal.substring(retVal.length - 1) == ',')
                retVal = retVal.substring(0, retVal.length - 1);

        }
    });

    return retVal;
}

function SetDefaultAdvSearch() {
    if (jQuery('#adv-search-set-default').button('option', 'label') == 'Set as Default') {
        settings.DefaultAddressBookSearchId = advSearch.AddressBookSearchId;

        PanteraScript.PanteraScriptService.SetDefaultAdvancedSearch(pjqSessionId, advSearch.AddressBookSearchId, SetDefaultAdvSearchC, onScriptError);
    }
    else {
        settings.DefaultAddressBookSearchId = '00000000-0000-0000-0000-000000000000';
        PanteraScript.PanteraScriptService.ClearDefaultAdvancedSearch(pjqSessionId, advSearch.AddressBookSearchId, SetDefaultAdvSearchC, onScriptError);
    }
}

function SetDefaultAdvSearchC(response) {
    if (jQuery('#adv-search-set-default').button('option', 'label') == 'Set as Default')
        jQuery('#adv-search-set-default').button('option', 'label', 'Remove Default Search');
    else
        jQuery('#adv-search-set-default').button('option', 'label', 'Set as Default');
}

function advCountryChanged() {
    if (jQuery('#search-contact-country').val() == 'CA') {
        jQuery('#search-contact-state-us').addClass('pjq-hidden');
        jQuery('#search-contact-state-ca').removeClass('pjq-hidden');
        jQuery('#search-contact-state-ca').val('');
        jQuery('#search-contact-zip').val('');
        jQuery('#search-contact-zip').mask("a9a-9a9");
        jQuery('#search-contact-zip').removeClass('zipcodeUS');
        jQuery('#search-contact-zip').addClass('zipcodeCA');
        jQuery('#search-contact-searchzip').val('');
        jQuery('#search-contact-searchzip').mask("a9a-9a9");
        jQuery('#search-contact-searchzip').removeClass('zipcodeUS');
        jQuery('#search-contact-searchzip').addClass('zipcodeCA');
    } else {
        jQuery('#search-contact-state-ca').addClass('pjq-hidden');
        jQuery('#search-contact-state-us').removeClass('pjq-hidden');
        jQuery('#search-contact-state-us').val('');
        jQuery('#search-contact-state-us').focus();
        jQuery('#search-contact-zip').val('');
        jQuery('#search-contact-zip').mask("99999");
        jQuery('#search-contact-zip').addClass('zipcodeUS');
        jQuery('#search-contact-zip').removeClass('zipcodeCA');
        jQuery('#search-contact-searchzip').val('');
        jQuery('#search-contact-searchzip').mask("99999");
        jQuery('#search-contact-searchzip').addClass('zipcodeUS');
        jQuery('#search-contact-searchzip').removeClass('zipcodeCA');
    }
}


dhtmlXToolbarObject.prototype.tryShowItem = function (item) {
    try {
        this.showItem(item);
    } catch (err) { }
}

dhtmlXToolbarObject.prototype.tryHideItem = function (item) {
    try {
        this.hideItem(item);
    } catch (err) { }
}

dhtmlXToolbarObject.prototype.tryEnableItem = function (item) {
    try {
        this.enableItem(item);
    } catch (err) { }
}

dhtmlXToolbarObject.prototype.tryDisableItem = function (item) {
    try {
        this.disableItem(item);
    } catch (err) { }
}


function updateAddInfo() {
    //Does nothing - to be overridden if needed per customer
}

function AdvSearchInactiveLogic() {
    if (jQuery('#search-company-isblacklisted').val() == 'true') {
        jQuery('#search-contact-isblacklisted').val('true');
        jQuery('#search-contact-isblacklisted').prop('disabled', true);
    }
    else
        jQuery('#search-contact-isblacklisted').prop('disabled', false);
}